import {
  EnvironmentInjector,
  inject,
  Injectable,
  runInInjectionContext,
} from '@angular/core';
import {
  Firestore,
  doc,
  docData,
  setDoc,
} from '@angular/fire/firestore';
import { from, Observable } from 'rxjs';

import { UserProfile } from '../models/role.model';
import { ProfileApi, ProfilePatch } from './profile.api';

@Injectable({ providedIn: 'root' })
export class FirebaseProfileApi implements ProfileApi {
  private readonly firestore = inject(Firestore);
  private readonly injector = inject(EnvironmentInjector);

  loadProfile(uid: string): Observable<UserProfile> {
    return runInInjectionContext(this.injector, () => {
      const ref = doc(this.firestore, `users/${uid}`);
      return docData(ref, { idField: 'uid' }) as Observable<UserProfile>;
    });
  }

  updateProfile(uid: string, patch: ProfilePatch): Observable<void> {
    return runInInjectionContext(this.injector, () => {
      const ref = doc(this.firestore, `users/${uid}`);

      // merge: true => schreibt/updated nur die Felder im patch
      return from(setDoc(ref, patch as Record<string, unknown>, { merge: true })).pipe(
        // setDoc liefert void; from(...) liefert Observable<void>
      );
    });
  }
}
